import React from 'react';
import ModalDialog from '../../widgets/ModalDialog/ModalDialog';
import PropTypes from "prop-types";
import AxiosClient from "../../../_helpers/http.helper";
import config from "../../../config";
import validator from "validator";
export class UpdateMetaData extends React.Component {

    static get propTypes() {
        return {
            showModal: PropTypes.bool.isRequired,
            selectedRow: PropTypes.object.isRequired,
            scrubbedStatus: PropTypes.bool.isRequired,
            courses: PropTypes.array.isRequired,
            showSecondModal: PropTypes.func.isRequired,
            refreshSearch: PropTypes.func.isRequired
        };
    }

    onMetadataFormEdit = (fieldKey, value) => {
        let tempData = { ...this.state.dataset };
        tempData[fieldKey].value = value;
        this.setState({
            dataSet: tempData
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            metadataUpdates: {},
            dataset: {
                "Collection Id": {
                    "name": "collectionId",
                    "accessName": "collectionId",
                    "value": "",
                    "size": 1,
                    "disabled": true
                },
                "ISBN": {
                    "name": "isbn",
                    "accessName": "isbn13",
                    "value": "",
                    "size": 1,
                    "disabled": true
                },
                "Title": {
                    "name": "title",
                    "accessName": "title",
                    "value": "",
                    "size": 2,
                    "disabled": false
                },
                "Description": {
                    "name": "description",
                    "accessName": "description",
                    "value": "",
                    "size": 5,
                    "disabled": false
                },
                "Keywords": {
                    "name": "keywords",
                    "accessName": "keywords",
                    "value": "",
                    "size": 2,
                    "disabled": false
                },
                "Course Codes": {
                    "name": "courseCodes",
                    "accessName": "courses",
                    "value": "",
                    "size": 3,
                    "disabled": false
                },
                "Thumbnail": {
                    "name": "thumbnail",
                    "accessName": "thumbnailUrl",
                    "value": "",
                    "size": 3,
                    "disabled": false
                },
                "Attribution": {
                    "name": "attribution",
                    "accessName": "creator",
                    "value": "",
                    "size": 1,
                    "disabled": true
                },
                "Product Type": {
                    "name": "productType",
                    "accessName": "productType",
                    "value": "",
                    "size": 1,
                    "disabled": false
                },
                "isbn10": {
                    "name": "isbn10",
                    "accessName": "isbn10",
                    "value": "",
                    "size": 1,
                    "disabled": true
                },
                "Author": {
                    "name": "author",
                    "accessName": "author",
                    "value": "",
                    "size": 1,
                    "disabled": false
                },
                "Rights Format Restriction": {
                    "name": "rightsFormatRestriction",
                    "accessName": "rightsFormatRestriction",
                    "value": "",
                    "size": 1,
                    "disabled": false
                },
                "CF Copyright Year": {
                    "name": "cfCopyrightYear",
                    "accessName": "cfCopyrightYear",
                    "value": "",
                    "size": 1,
                    "disabled": false
                },
                "Geo Origin": {
                    "name": "geoOrigin",
                    "accessName": "geo",
                    "value": "",
                    "size": 1,
                    "disabled": false
                },
                "unscrubbed": {
                    "name": "isUnscrubbed",
                    "accessName": "",
                    "value": "",
                    "size": 1,
                    "disabled": true
                },
            }
        };
        this.setData();

    }

    setData = () => {
        Object.keys(this.state.dataset).map((item) => {
            const data = this.state.dataset[item];
            let value = this.props.selectedRow[data.accessName] || "";
            const {scrubbedStatus, keywords} = this.props;

            if (item === "Geo Origin") {
                value = value.code;
            } else if (item === "unscrubbed") {
                value = scrubbedStatus;
            } else if (item === "Keywords") {
                value = keywords;
            } else if (item === "Course Codes") {
                value = this.buildCourseList();
            } else if (item === "Rights Format Restriction") {
                if (value === undefined || value === "") {
                    value = null;
                }
            }
            let tempData = this.state.dataset[item];
            tempData.value = value;
            this.setState({
                dataset: { ...this.state.dataset, tempData }
            });
        });

    };

    buildCourseList = () => {
        return this.props.courses.map(courseItem => courseItem.courseId).join(", ");
    };

    buildItem = () => {
        let row = [];
        Object.keys(this.state.dataset).map((item, index) => {
            const data = this.state.dataset[item];
            row.push(<div className={`metadata-item-container disable-${data.disabled}`} key={index}>
                <div className="item-name">{item}</div>
                <textarea
                    disabled={data.disabled}
                    className="pe-multiLineText"
                    id={`field-${data.name}`}
                    rows={data.size}
                    value={data.value || ""}
                    placeholder={`Enter new value for ${item}.`}
                    onChange={e =>
                        this.onMetadataFormEdit(item, e.target.value)
                    }
                />
            </div>);
        });
        return row;
    };

    onSuccess = () => {

        let payload = this.buildPayload();
        let update = this.validation(payload);
        const baseUrl = config.collectionService.baseUrl + config.collectionService.routes.updateCuratedCollection + this.props.selectedRow.collectionId;
        update ? this.sendRequest(baseUrl, payload) : null;
    };

    sendRequest = (baseUrl, payload) => {
        return AxiosClient.put(
            baseUrl,
            payload
        ).then((res) => {
            this.props.hideModal();
            this.props.showSecondModal("Success", "Curated collection successfully updated", true);
        }).catch((error) => {
            if (error.response.status === 400) {
                this.props.hideModal();
                this.props.showSecondModal("Error", error.response.data.message);
            } else {
                this.props.hideModal();
                this.props.showSecondModal("Error", "An error occurred while updating please try again");
            }
        });
    };

    validation = () => {
        let update = true;
        const nullAllowedItems = ["Rights Format Restriction","Description","Thumbnail","Keywords","Author","CF Copyright Year"];
        Object.keys(this.state.dataset).map((item) => {
            const data = this.state.dataset[item];
            if (nullAllowedItems.includes(item)) {
                if (!this.validate(item, data.value, false)) {
                    update = false;
                }
            } else if (!this.validate(item, data.value, true)) {
                update = false;
            }
        });
        return update;
    };

    validate = (itemName, dataToValidate, checkNull) => {
        if (checkNull) {
            if (itemName === "unscrubbed" && (dataToValidate === true || dataToValidate === false)) {
                return true;
            } else if(itemName==="ISBN" || itemName ==="isbn10"){
                if(!validator.isEmpty(this.state.dataset.ISBN.value) || !validator.isEmpty(this.state.dataset.isbn10.value)){
                    return true;
                }else{
                    this.props.showSecondModal("Warning ! ISBN field cannot be empty");
                    return false;
                }
            } else if (validator.isEmpty(dataToValidate)) {
                this.props.showSecondModal("Warning !", itemName + " field cannot be empty");
                return false;
            }
        }
        if (itemName === "Rights Format Restriction") {
            if (dataToValidate === null) {
                return true;
            }
            else if (!(validator.isEmpty(dataToValidate) || dataToValidate.toLowerCase().trim() === "print_only" || dataToValidate.toLowerCase().trim() === "digital_only" || dataToValidate.toLowerCase().trim() === "print_rental")) {
                this.props.showSecondModal("Warning !", "Please re-check " + itemName + " field");
                return false;
            } else {
                return true;
            }
        } else if (itemName === "Geo Origin") {
            if (!(dataToValidate.toUpperCase() === "CA" || dataToValidate.toUpperCase() === "US")) {
                this.props.showSecondModal("Warning !", "Please re-check " + itemName + " field");
                return false;
            } else {
                return true;
            }
        } else if (itemName === "CF Copyright Year") {
            let itIsNumber = /^\d{4}$/.test(dataToValidate);
            if (dataToValidate === null) {
                return true;
            }
            else if(!(validator.isEmpty(dataToValidate) || itIsNumber)) {
                this.props.showSecondModal("Warning !", "Please re-check " + itemName + " field");
                return false;
            } else {
                return true;
            }
        } else if (itemName === "Product Type") {
            if (!(dataToValidate.toLowerCase().trim() === "curatedbasic" || dataToValidate.toLowerCase().trim() === "curatedenhanced")) {
                this.props.showSecondModal("Warning !", "Please re-check " + itemName + " field");
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    };

    buildPayload = () => {
        let payload = {};
        Object.keys(this.state.dataset).map((item) => {
            const data = JSON.parse(JSON.stringify(this.state.dataset[item]));
            if (item === "Course Codes") {
                let course = data.value;
                course = course.split(',');
                let coursePayload = {};
                course.map((course) => {
                    course = course.trim();
                    if (course !== "") {
                        coursePayload = {
                            ...coursePayload,
                            [course]: null
                        };
                    }
                });
                data.value = coursePayload;
            } else if (item === "Rights Format Restriction") {
                if (data.value !== null) {
                    if (validator.isEmpty(data.value)) {
                        data.value = null;
                    } else {
                        data.value = data.value.toLowerCase().trim();
                    }
                }

            } else if(item ==="Product Type"){
                if (validator.isEmpty(data.value)) {
                    data.value = null;
                }else if (data.value.toLowerCase().trim() === "curatedbasic"){
                    data.value ="CuratedBasic";
                }else if(data.value.toLowerCase().trim() ==="curatedenhanced"){
                    data.value ="CuratedEnhanced";
                }
            }
            payload = {
                ...payload,
                [data.name]: data.value
            };
        });
        return payload;
    };

    render() {
        const {showModal, hideModal} = this.props;
        const  {enableButton} = this.state;
        return (
            <ModalDialog
                title={"Update Metadata"}
                showModal={showModal}
                onSuccess={this.onSuccess}
                showSuccess={enableButton}
                onCancel={hideModal}>
                {this.buildItem()}
            </ModalDialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/UpdateMetaData.js